export const PRIMARY = "#61dafb"